import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { FiAward, FiTool, FiZap, FiCheckCircle } from "react-icons/fi";

const QualityAssuranceSection = () => {
  const { t } = useTranslation();

  const qualityPoints = [
    {
      icon: <FiAward size={24} />,
      titleKey: "quality.certified.title",
      descKey: "quality.certified.desc"
    },
    {
      icon: <FiTool size={24} />,
      titleKey: "quality.installation.title",
      descKey: "quality.installation.desc"
    },
    {
      icon: <FiZap size={24} />,
      titleKey: "quality.safety.title",
      descKey: "quality.safety.desc"
    },
    {
      icon: <FiCheckCircle size={24} />,
      titleKey: "quality.testing.title",
      descKey: "quality.testing.desc"
    }
  ];

  return (
    <section className="bg-gray-100 py-20 px-6 border-t">
      <div className="max-w-6xl mx-auto">
        <motion.h2
          className="text-3xl font-bold text-gray-900 text-center mb-4"
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          {t("quality.title")}
        </motion.h2>
        <motion.p
          className="text-center text-gray-600 mb-12 max-w-2xl mx-auto"
          initial={{ opacity: 0, y: -10 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, delay: 0.2 }}
        >
          {t("quality.subtitle")}
        </motion.p>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2 gap-10">
          {qualityPoints.map((point, index) => (
            <motion.div
              key={index}
              className="bg-white p-6 rounded-lg shadow hover:shadow-md transition"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: index * 0.1 }}
              viewport={{ once: true }}
            >
              <div className="flex items-center space-x-4 mb-3 text-primary">
                {point.icon}
                <h3 className="text-lg font-bold text-gray-800">
                  {t(point.titleKey)}
                </h3>
              </div>
              <p className="text-sm text-gray-600">{t(point.descKey)}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default QualityAssuranceSection;
